import { FetchContext, FetchError, FetchOptions, FetchResponse, ofetch } from 'ofetch';

// const baseURL = 'http://10.244.112.20:8081/bdex-api';  // nuc
//const baseURL = 'http://localhost:8081/bdex-api';      // dev
const baseURL = process.env.NODE_ENV !== "production" ? "http://localhost:8081/bdex-api" : "/opendata/bdex-api/bdex-api";
class ApiDataService{
  baseApi : string = baseURL;

  onRequestError = async (error:FetchError) =>{
    // Log error
    console.log('[fetch request error]', error.request, error.data);
  }
  get(resource : string, slug = '')  {
    const s = slug ? `/${slug}` : '';
    const options : FetchOptions = {
      baseURL : baseURL
    };

    return ofetch(`${this.baseApi}${resource}${s}`, options);
  }

  query(resource : string, params : any)  {
    const options : FetchOptions = {
      baseURL : baseURL,
      params
    };

    return ofetch(`${this.baseApi}${resource}`, options);
  }
  post(resource : string, payload : never | any) {
    const options : FetchOptions = {
      baseURL : baseURL,
      body : { ...payload },
      method: "POST"
    };
    return ofetch(`${this.baseApi}${resource}`, options);
  }
  put(resource : string, payload : never | any) {
    const options : FetchOptions = {
      baseURL : baseURL,
      body : { ...payload },
      method: "PUT"
    };
    return ofetch(`${this.baseApi}${resource}`, options);
  }

  delete(resource : string, payload : never | any) {
    const options : FetchOptions = {
      baseURL : baseURL,
      body : { ...payload },
      method: "DELETE"
    };
    return ofetch(`${this.baseApi}${resource}`, options);
  }
}

export default ApiDataService;
